import {setCacheNameDetails as workbox_core_setCacheNameDetails} from '/opt/build/repo/node_modules/workbox-core/setCacheNameDetails.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/opt/build/repo/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/opt/build/repo/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "frontend"});


self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/css/app.2fc2dfe6.css",
    "revision": null
  },
  {
    "url": "/css/chunk-vendors.4a462ff0.css",
    "revision": null
  },
  {
    "url": "/images/alert.svg",
    "revision": "a0b734f626df5aa0c527bbd1e047a69b"
  },
  {
    "url": "/images/cet-logo.png",
    "revision": "9e899fb80f5f2d5f06b7e035ef1b6d8e"
  },
  {
    "url": "/images/filter.svg",
    "revision": "6d09ff01426031f8e06b5336d69c7132"
  },
  {
    "url": "/images/locate.svg",
    "revision": "8b152ced375f2b897d1eae8de806c55a"
  },
  {
    "url": "/images/marker-0.svg",
    "revision": "49115a2dd2fad058ca899f1c7c409ad8"
  },
  {
    "url": "/images/marker-1.svg",
    "revision": "fe0f861bbca0ae356e60fa6807e2df3b"
  },
  {
    "url": "/images/marker-2.svg",
    "revision": "5eb24f933b0be65fa1d222886cba64a2"
  },
  {
    "url": "/images/marker-3.svg",
    "revision": "1f3aae2f9b01bc40386a05a1f738c1ee"
  },
  {
    "url": "/images/marker-EXISTING_COMPLETE.svg",
    "revision": "1dc113572125246aac9fbf860ce0d82e"
  },
  {
    "url": "/images/marker-EXISTING_INCOMPLETE.svg",
    "revision": "e71732b69c21ae1c50191ce061c24a89"
  },
  {
    "url": "/images/marker-NEW.svg",
    "revision": "403b5f8d3691174604dc5a0278064a3d"
  },
  {
    "url": "/images/marker-REPORTED.svg",
    "revision": "28d5d686acac6c4b402765967de4d503"
  },
  {
    "url": "/images/marker-default.svg",
    "revision": "8d369fd2aabf3898ea0ba19af9f84663"
  },
  {
    "url": "/images/marker-white.svg",
    "revision": "1fca2883690887067a5d07c78cfcb299"
  },
  {
    "url": "/images/menu-pic.png",
    "revision": "9494914e7f2cc9edd2dd5b46b457f472"
  },
  {
    "url": "/images/now.svg",
    "revision": "972c8d2569e3223259d05d887aabdecf"
  },
  {
    "url": "/images/safety_notice/1.png",
    "revision": "b76d575c1e1704f75119d4cdd923e89a"
  },
  {
    "url": "/images/safety_notice/2.png",
    "revision": "87ff2270c2c8d49b27a7655e0b5989ce"
  },
  {
    "url": "/images/safety_notice/3.png",
    "revision": "d08ebb7a58270c4e38de7273c5ff41f2"
  },
  {
    "url": "/images/safety_notice/4.png",
    "revision": "fc7b11901d9329049e414ad4a37d77e8"
  },
  {
    "url": "/images/safety_notice/5.png",
    "revision": "347c41f4a855b10fe142b6a14f901b5a"
  },
  {
    "url": "/images/search.svg",
    "revision": "b48aa2becb4aed1a9a2bc265b4188bc6"
  },
  {
    "url": "/images/tutorial/create-1.jpg",
    "revision": "4a3769dea980322fa63d5155b7f4f250"
  },
  {
    "url": "/images/tutorial/create-2.jpg",
    "revision": "7701218d9a4ae687f962a20c07f31d8f"
  },
  {
    "url": "/images/tutorial/create-3.jpg",
    "revision": "640502cf36ac03d861947b43078241ee"
  },
  {
    "url": "/images/tutorial/create-4.jpg",
    "revision": "2ed50a728761df4bc0828f686cb3c5d7"
  },
  {
    "url": "/images/tutorial/create-5.jpg",
    "revision": "a7efa442f17945cbb3e6e98174e35689"
  },
  {
    "url": "/images/tutorial/create-6.jpg",
    "revision": "62278e0bc2451757185a067d03a75b87"
  },
  {
    "url": "/images/tutorial/create-7.jpg",
    "revision": "af9185b03831762556d01b209b881c65"
  },
  {
    "url": "/images/tutorial/update-1.jpg",
    "revision": "255f24230658f8d194ce1709f42b6482"
  },
  {
    "url": "/images/tutorial/update-2.jpg",
    "revision": "5cb50b6efc0d016dc61151f9558414ad"
  },
  {
    "url": "/images/tutorial/update-3.jpg",
    "revision": "c4edeec2e27c89d31b9b5f37ea1a2b68"
  },
  {
    "url": "/images/tutorial/update-4.jpg",
    "revision": "ef886a1eadd9914056eb607013ca4cc8"
  },
  {
    "url": "/images/zoom-in.svg",
    "revision": "9976f26e97d82ad1e6573905e835eb72"
  },
  {
    "url": "/images/zoom-out.svg",
    "revision": "7b27db018e8ec845a2f1692cff537b81"
  },
  {
    "url": "/img/remove.9fbe351e.svg",
    "revision": null
  },
  {
    "url": "/index.html",
    "revision": "60cc83eb58566701910125bf021a8f05"
  },
  {
    "url": "/js/app.01a02edd.js",
    "revision": null
  },
  {
    "url": "/js/chunk-vendors.0e7ec79e.js",
    "revision": null
  },
  {
    "url": "/manifest.json",
    "revision": "cdc26ad6605b9b9909de246fd71d2fc6"
  },
  {
    "url": "/og.png",
    "revision": "e12851da9d06560b58f8382beee3a126"
  },
  {
    "url": "/robots.txt",
    "revision": "b6216d61c03e6ce0c9aea6ca7808f7ca"
  }
], {});








